import {getUserProfile, logout} from '@hublot-io/core-api/client'

import {ClientService} from '@/services/ClientService'

import {contexts} from './context'

export const state = {
  authenticated: false,
  user: null,
  userProfile: {},
  client: {}
}

export const mutations = {
  login(state, {authenticated, userProfile, client}) {
    state.authentication.authenticated = authenticated
    state.authentication.userProfile = userProfile
  },
  logout(state) {
    state.authentication.authenticated = false
  },
  updateClient(state, client) {
    state.authentication.client = {...client}
  }
}

export const actions = {
  logout({commit}) {
    logout()
    commit('logout')
  },
  getUserProfile({commit, dispatch, rootState}) {
    const contextMatching = [
      {
        context: contexts.POISSONNERIE_CONTEXT,
        key: 'hublot_clientid'
      },
      {
        context: contexts.BOUCHERIE_CONTEXT,
        key: 'carnot_clientid'
      }
    ]

    const contextList = contextMatching
      .filter(context => rootState.authentication.userProfile.attributes[context.key])
      .map(context => context.context)
    dispatch('setAvailableContexts', contextList)
    if (contextList.length === 1) {
      dispatch('switchContext', contextList[0])
    }
    dispatch('getClient')
  },
  getClient({commit, dispatch, rootState, getters}) {
    ClientService.get(rootState.context.currentContext, getters.contextClientId).then(client => {
      dispatch('joinAndListen', client[0].serial)
      commit('updateClient', client[0])
      dispatch('getDatabase')
    })
  },
  login({commit, dispatch}) {
    return getUserProfile()
      .then(userProfile => {
        commit('login', {authenticated: true, userProfile})
        dispatch('getUserProfile')
      })
      .catch(() => {
        commit('login', {authenticated: false})
      })
  }
}

export default {actions, mutations, state}
